import React, { useState } from 'react';
import { api } from './api';
import { Server } from './types';

interface Props {
    onClose: () => void;
    onAdded: (server: Server) => void;
}

export default function AddServerModal({ onClose, onAdded }: Props) {
    const [name, setName]             = useState('');
    const [host, setHost]             = useState('');
    const [description, setDesc]      = useState('');
    const [tags, setTags]             = useState('');
    const [error, setError]           = useState('');
    const [busy, setBusy]             = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setBusy(true);
        try {
            const server = await api.post<Server>('/servers', { name, host, description, tags });
            onAdded(server);
            onClose();
        } catch (err: any) {
            setError(err.message || 'Ошибка при добавлении');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-card" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Добавить сервер</h2>
                    <button className="modal-close" onClick={onClose}>✕</button>
                </div>

                <form onSubmit={handleSubmit}>
                    {error && <div className="error-message">{error}</div>}

                    <div className="form-group">
                        <label>Название *</label>
                        <input
                            type="text"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            placeholder="Production Web Server"
                            required
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label>Хост или IP *</label>
                        <input
                            type="text"
                            value={host}
                            onChange={e => setHost(e.target.value)}
                            placeholder="192.168.1.1 или example.com"
                            required
                        />
                        <span className="field-hint">IP-адрес или доменное имя</span>
                    </div>

                    <div className="form-group">
                        <label>Описание</label>
                        <input
                            type="text"
                            value={description}
                            onChange={e => setDesc(e.target.value)}
                            placeholder="Основной веб-сервер в ДЦ Москва"
                        />
                    </div>

                    <div className="form-group">
                        <label>Теги</label>
                        <input
                            type="text"
                            value={tags}
                            onChange={e => setTags(e.target.value)}
                            placeholder="web, production, москва"
                        />
                        <span className="field-hint">Через запятую — для группировки</span>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn-secondary" onClick={onClose}>
                            Отмена
                        </button>
                        <button type="submit" className="btn-primary" disabled={busy}>
                            {busy ? 'Добавляем...' : 'Добавить'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
